import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-tenant-api-invoice',
  templateUrl: './tenant-api-invoice.component.html',
  styleUrl: './tenant-api-invoice.component.scss',
})
export class TenantApiInvoiceComponent {
  invoiceId?: string;
  tenantId?: string;

  constructor(private route: ActivatedRoute) {
    const params = this.route.snapshot.params;
    this.tenantId = params['tenantId'];
    this.invoiceId = params['invoiceId'];
  }
}
